/**
 * The live command client — binds the injectable {@link ThemeCommandClient} to
 * the real `brands-api` GraphQL layer (which authenticates via the browser
 * Firebase session). The app passes this; headless proofs pass a fake.
 */
import {
  updateTheme as apiUpdateTheme,
  publishBrandTheme as apiPublishBrandTheme,
  generateThemeColorsFromUrl as apiGenerateThemeColorsFromUrl,
} from "@/data/brands-api";
import { themeTreatmentColumnSupported } from "@/data/theme-capabilities";
import type { ThemeCommandClient } from "./types";

export const liveClient: ThemeCommandClient = {
  updateTheme: apiUpdateTheme,
  publishBrandTheme: apiPublishBrandTheme,
  generateThemeColorsFromUrl: apiGenerateThemeColorsFromUrl,
  supportsThemeTreatment: themeTreatmentColumnSupported,
};
